import { __decorate } from "tslib";
import { Component, Vue } from "vue-property-decorator";
import { State, Mutation } from "vuex-class";
let PiSysContent = class PiSysContent extends Vue {
    constructor() {
        super(...arguments);
        this.tagList = [{ name: "用户管理" }];
        // mounted() {}
    }
    handleClose(item, index) {
        if (this.sys.toData.path == item.url) {
            let url = "";
            if (index === 0) {
                url = this.sys.goRouter[index + 1].url;
            }
            else {
                url = this.sys.goRouter[index - 1].url;
            }
            this.$router.push(url);
        }
        this.UP_GOROUTER(index);
    }
};
__decorate([
    State("sys")
], PiSysContent.prototype, "sys", void 0);
__decorate([
    Mutation("UP_GOROUTER")
], PiSysContent.prototype, "UP_GOROUTER", void 0);
PiSysContent = __decorate([
    Component
], PiSysContent);
export default PiSysContent;
